const difficultyTooltipText = {
  Recall: 'Recall: requires student to remember a piece of knowledge or fact',
  Application: 'Application: requires student to apply knowledge to a specify case history',
  Synthesis: 'Synthesis: requires student to apply knowledge from several courses to deduce an answer'
};

export default difficultyTooltipText;
